<script lang="ts">
  import { onMount } from 'svelte';
  import type { AuthState } from '../lib/auth.svelte';
  import Loading from '../lib/Loading.svelte';
  import type { Router } from '../lib/router.svelte';

  let { auth, router }: { auth: AuthState; router: Router } = $props();
  let error = $state('');

  onMount(async () => {
    try {
      await auth.completeCallback();
      router.navigate('/');
    } catch {
      error = 'The sign-in response could not be completed. Please return and try again.';
    }
  });
</script>

<main class="centred">
  {#if error}<section class="error-panel" role="alert"><h1>Sign-in failed</h1><p>{error}</p><a href="/">Return to sign in</a></section>{:else}<Loading />{/if}
</main>
